var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.0004 25C15.663 24.9996 18.2498 24.1137 20.3536 22.4818C22.4574 20.8499 23.9588 18.5646 24.6213 15.9858C25.2837 13.407 25.0698 10.6811 24.013 8.23726C22.9563 5.7934 21.1167 3.7704 18.7841 2.48674C16.4514 1.20308 13.758 0.731664 11.128 1.14671C8.49804 1.56177 6.08077 2.83971 4.25677 4.77935C2.43278 6.71899 1.30567 9.21017 1.05288 11.8607C0.80009 14.5112 1.43598 17.1705 2.86045 19.42L1.00045 25L6.58044 23.14C8.49988 24.3582 10.7271 25.0035 13.0004 25Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Chat.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Chat;

Chat.default = Chat;
